import {
  governedReview,
  governedReviewDetail,
  governedReviewPage,
  reviewCase,
  reviewCaseDetail,
  reviewCasePage,
  reviewCaseOperation,
  reviewModerationInput,
  type ReviewCaseOperation,
  type ReviewCaseQuery,
  type ReviewModerationInput,
  type ReviewModerationQueueQuery,
} from '@dental-staffing-platform/shared';
import { req } from './admin-client.js';

const base = '/api/admin/review-moderation';
function path(route: string, query: Record<string, string | number | undefined>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query))
    if (value !== undefined && value !== '') params.set(key, String(value));
  return `${base}${route}?${params}`;
}
export const reviewModerationApi = {
  reviews: async (query: Partial<ReviewModerationQueueQuery>) =>
    governedReviewPage.parse(await req(path('/reviews', query))),
  review: async (id: string, page = 1) =>
    governedReviewDetail.parse(
      await req(path(`/reviews/${encodeURIComponent(id)}`, { page, pageSize: 12 }))
    ),
  decide: async (id: string, input: ReviewModerationInput) =>
    governedReview.parse(
      await req(`${base}/reviews/${encodeURIComponent(id)}/decisions`, {
        method: 'POST',
        body: JSON.stringify(reviewModerationInput.parse(input)),
      })
    ),
  cases: async (query: Partial<ReviewCaseQuery>) =>
    reviewCasePage.parse(await req(path('/cases', query))),
  case: async (id: string, page = 1) =>
    reviewCaseDetail.parse(
      await req(path(`/cases/${encodeURIComponent(id)}`, { page, pageSize: 12 }))
    ),
  operate: async (id: string, input: ReviewCaseOperation) =>
    reviewCase.parse(
      await req(`${base}/cases/${encodeURIComponent(id)}/operations`, {
        method: 'POST',
        body: JSON.stringify(reviewCaseOperation.parse(input)),
      })
    ),
};
